import { getHeaders } from "utils/Utils";
import client from "./client";

const endpoint = "intelligence/finance/currency-exchange/";

const getLatestCurrencyExchange = () => {
  return client.get(`${endpoint}latest`, getHeaders());
};

export { getLatestCurrencyExchange };
